<cp-auth-page-common>

  <div class="AuthPageControlsContainer"
    (keyup.enter)="onLoginFormSubmit()">

    <div class="AuthPageControlsHeader">
      {{ 'DESIGN_B.USER_LOGIN.LOGIN' | translate }}
    </div>

    <div class="AuthPageControlsLabel">
      {{ 'DESIGN_B.USER_LOGIN.LOGIN_NAME' | translate }}
    </div>

    <div class="EmailLoginInputContainer">
      <cp-form-input
        [form]="formGroup"
        [controlName]="LOGIN"
        [valueType]="ValueType.TEXT"
        [renderNameProperty]="'login'"
        [type]="InputTagType.INPUT"
        [placeholder]="showPlaceHolder ? null : ''">
      </cp-form-input>
    </div>

    <div class="AuthPageControlsLabel">
      {{ 'DESIGN_B.USER_LOGIN.PASSWORD' | translate }}
    </div>

    <div>
      <cp-form-input [form]="formGroup"
        [valueType]="ValueType.PASSWORD"
        [renderNameProperty]="'password'"
        [controlName]="PASSWORD"
        [placeholder]="showPlaceHolder ? null : ''">
      </cp-form-input>
    </div>

    <div class="StayLoggedInContainer">
      <cp-form-input [form]="formGroup"
        [valueType]="ValueType.CHECKBOX"
        [label]="'DESIGN_B.USER_LOGIN.STAY_LOGGED_IN' | translate"
        [controlName]="STAY_LOGGED_IN">
      </cp-form-input>
    </div>

    <hr>

      <div class="AuthPageControlsFooter">
        <cp-inline-button [size]="ButtonSize.SMALL"
          [text]="'DESIGN_B.USER_LOGIN.PASSWORD_FORGOTTEN' | translate"
          [disabled]="inProgress"
          (buttonClick)="onResetUserPassword()">
        </cp-inline-button>
        <cp-button [size]="ButtonSize.MEDIUM"
          [disabled]="!isValid || inProgress"
          [text]="'DESIGN_B.USER_LOGIN.LOGIN_BUTTON' | translate"
          [showSpinner]="inProgress"
          (buttonClick)="onLoginFormSubmit()">
        </cp-button>
      </div>

    </div>

    <!-- Wrong password or username -->
    <div class="AuthPageAlertMessageContainer">
      @if (loginFailed) {
        <cp-message-design-b-small
          [(visible)]="loginFailed"
          [messageText]="loginFailedText | translate">
        </cp-message-design-b-small>
      }
    </div>


  </cp-auth-page-common>

  <cp-message-design-b-global [onlyAuthMessages]="true">
  </cp-message-design-b-global>
  <cp-message-design-b-relative-content class="LoginPageHeaderMessage"
    [useMessageModel]="true"
    [visible]="isMessageVisible"
    (visibleChange)="isMessageVisible = $event">
  </cp-message-design-b-relative-content>
